module.exports = __webpack_public_path__ + "static/img/logo.6ba26247.png";